import { render, staticRenderFns } from "./PhoneAudio.vue?vue&type=template&id=bc865c20&scoped=true&lang=pug"
import script from "./PhoneAudio.vue?vue&type=script&lang=js"
export * from "./PhoneAudio.vue?vue&type=script&lang=js"
import style0 from "./PhoneAudio.vue?vue&type=style&index=0&id=bc865c20&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc865c20",
  null
  
)

export default component.exports